export default __webpack_public_path__ + "static/media/regulatory_check_thumbnail.db1aa822.png";